module.exports = __webpack_public_path__ + "img/twisports.ef880236.png";